const getViewRoleData = state => state?.appliedRoleData?.viewRoleData
const getSingleRoleDetail = state => state?.viewRoleDetails?.RoleDetails
const selector ={
    getViewRoleData,
     getSingleRoleDetail
}

export default selector;
